import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CreateOrUpdateJobRequest, HttpResponse, Job } from "@/types";

export function useCreateJob() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({ request }: { request: CreateOrUpdateJobRequest }) => {
      const path = `companies/${currentCompanyId}/jobs`;
      const res = await guacHttpClient.post<
        Job,
        HttpResponse<Job>,
        CreateOrUpdateJobRequest
      >(path, request);

      return res.data;
    },
  });

  return mutation;
}
